import { Link } from "react-router-dom"

const Button = () => {
    return (
       
        <Link className="btn" exact to="contact">Parlons de votre projet</Link>
        
    )
}
export default Button